
import Vue from "vue";
import { fetchWithBackoff } from "../../utils/fetchWithBackoff";

const LocationAPIService = class extends Vue {
  _DEBUG = false;

  constructor() {
    super();
    if (this._DEBUG) {
      this.debugMessage('BOOTSTRAPPED LOCATION API SERVICE');
    }
  }

  debugMessage(message) {
    if (this._DEBUG) {
      console.log(message);
    }
  }

  async fetchLocations(query = { tenantName: null, limit: 30, skip: 0 }) {
    if (!query.tenantName || !config) return;

    const claims = await this.$auth.getIdTokenClaims();
    const id_token = claims.__raw;
    if (!id_token) return;

    const url = `${config.API_GATEWAY}/location/userLocations?${new URLSearchParams(query).toString()}`;
    const request = new Request(url, {
      method: "GET",
      mode: "cors",
      cache: "default",
      withCredentials: true,
      headers: {
        Authorization: "Bearer " + id_token,
        "Content-Type": "application/json",
      },
    });

    return fetchWithBackoff(request);
  }
};

// Singleton Pattern Instantiate
if (!Vue.prototype.$LocationAPIService) {
  Vue.prototype.$LocationAPIService = new LocationAPIService();
}

export default Vue.prototype.$LocationAPIService;
